import { useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";
import Icon from "./Icon";

export default function ServiceCard({ service, index = 0 }) {
  const navigate = useNavigate();
  return (
    <div
      data-testid={`service-card-${service.slug}`}
      onClick={() => navigate(`/services/${service.slug}`)}
      className="group bg-white rounded-2xl border border-slate-200 hover:border-orange-400 hover:shadow-xl hover:-translate-y-1 transition-all duration-200 p-4 sm:p-5 flex flex-col cursor-pointer af-fade-up"
      style={{ animationDelay: `${index * 40}ms` }}
    >
      <div className="flex items-start justify-between">
        <span className="grid place-items-center w-12 h-12 rounded-xl bg-orange-50 text-brand-orange group-hover:bg-brand-orange group-hover:text-white transition-colors">
          <Icon name={service.icon} className="w-6 h-6" />
        </span>
        <span className="text-[10px] font-bold uppercase tracking-wide px-2 py-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
          {service.badge}
        </span>
      </div>
      <h3 className="mt-4 font-display font-bold text-slate-900 text-base leading-snug">{service.name}</h3>
      <p className="mt-1 text-sm text-slate-600 leading-relaxed line-clamp-2">{service.desc}</p>
      <div className="mt-3 flex items-center justify-between text-xs text-slate-500">
        <span className="font-mono-num font-semibold text-slate-900">{service.priceStarts} <span className="font-sans font-normal text-slate-400">onwards</span></span>
        <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" />{service.avgTime}</span>
      </div>
      <button
        data-testid={`service-card-book-btn-${service.slug}`}
        onClick={(e) => { e.stopPropagation(); navigate(`/book?service=${service.slug}`); }}
        className="mt-4 w-full rounded-xl bg-navy text-white text-sm font-semibold py-2.5 group-hover:bg-brand-orange active:scale-[0.98] transition-all"
      >
        Book Now
      </button>
    </div>
  );
}
